import React from 'react';
import HOCLoader from '../HOC/HOCLoader.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

class SideNotificationList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            order: 'desc',
            orderBy: 'created_at',
            selected: [],
            data: props.notificationData,
            page: 0,
            rowsPerPage: 10,
            clickValue: '',
            item: {},
            loader: false
        };
    }

    actionCallbacks(action, res) {
        if (action === 'view') {
            this.setState({ clickValue: 'view', item: res });
        }
    }
    componentDidMount() {
        this.props.notificationListAction();
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.notificationData.length !==
            this.props.notificationData.length
        ) {
            this.setState({
                data: this.props.notificationData,
                loader: this.props.notificationLoader
            });
        }
    }
    clickNotification = notification => {
        if (notification.route == 'BookingDetail') {
            this.props.history.push({
                pathname:
                    notification.webroute +
                    '/' +
                    notification.notification.payload.additionalData.params
                        .bookingDetail.key,
                bookingId:
                    notification.notification.payload.additionalData.params
                        .bookingDetail.key
            });
        } else if (notification.route == 'Offers') {
            this.props.history.push({
                pathname: notification.webroute
            });
        }
    };
    render() {
        const { data, rowsPerPage, page } = this.state;
        const { notificationData } = this.props;

        //View Redirection
        if (this.state.clickValue) {
            if (this.state.item.route == 'BookingDetail') {
                this.props.history.push({
                    pathname:
                        this.state.item.webroute +
                        '/' +
                        this.state.item.notification.payload.additionalData
                            .params.bookingDetail.key,
                    bookingId: this.state.item.notification.payload
                        .additionalData.params.bookingDetail.key
                });
            } else if (this.state.item.route == 'Offers') {
                this.props.history.push({
                    pathname: this.state.item.webroute
                });
            }
        }
        //View Redirection

        return (
            <HOCLoader loading={this.props.notificationLoader}>
                <ul>
                    {notificationData.length == 0 && (
                        <li>
                            <a>
                                <h5>No Notification Found</h5>
                            </a>
                        </li>
                    )}
                    {notificationData &&
                        notificationData.slice(0, 14).map((noti, index) => {
                            return (
                                <li
                                    key={index}
                                    onClick={() => this.clickNotification(noti)}
                                >
                                    <a href="javascript:void(0);">
                                        <h5>
                                            {noti.notification.payload.title}
                                        </h5>
                                        <p>{noti.notification.payload.body}</p>
                                    </a>
                                </li>
                            );
                        })}
                </ul>
            </HOCLoader>
        );
    }
}

const mapStateToProps = ({ notification }) => {
    return {
        notificationData: notification.notificationData,
        notificationLoader: notification.notificationLoader
    };
};
const composedComponent = compose(connect(mapStateToProps, actions));

export default composedComponent(injectIntl(withRouter(SideNotificationList)));



// WEBPACK FOOTER //
// ./src/components/Customer/SideNotificationList.jsx